var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg-icon',_vm._b({},'svg-icon',_vm.props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }